@if (isServer || (isBrowser && !promotionCodeData())) {
	<div data-test-id="promotion-code-page">
		@if (storytellingImage()) {
			<vp-storytelling
				[image]="storytellingImage()"
				[isFullscreen]="true"
			>
				<sb-promotion-code-promo-form
					#promoForm
					[promotionCode]="promotionCode()"
					(promotionCodeData)="onPromotionCodeData($event)"
				/>
			</vp-storytelling>
		}
		<section class="section-spacing">
			<div class="section-inner section-gap">
				<div class="column-gap !grid grid-cols-1 md:grid-cols-2">
					<div
						class="flex flex-col gap-4 md:gap-6 2xl:gap-8"
						data-test-id="promotion-text"
					>
						<sb-heading-group
							[overline]="
								'storyblok.pages.promotion-code.overline'
									| translate
							"
							[title]="
								'storyblok.pages.promotion-code.title'
									| translate
							"
							headingType="h1"
						/>
						<sb-richtext
							[content]="
								'storyblok.pages.promotion-code.content'
									| translate
							"
							data-test-id="promotion-code-content"
						/>
					</div>
					<sb-accordion
						[items]="faqItems"
						class="block"
						data-test-id="promo-code-faqs"
					/>
				</div>
			</div>
		</section>
		@if (cards()?.length > 0) {
			<sb-card-section [cards]="cards()" [title]="cardsTitle()" />
		}
		@if (reference()?.length > 0) {
			<sb-reference [reference]="reference()[0].reference" />
		}
	</div>
} @else {
	<div data-test-id="promotion-code-results-page">
		<sb-searchable-list-section
			[hideFilter]="false"
			[hidePriceFilter]="true"
			[persuadeCards]="mappedPromoHotels()"
			[title]="promoCodesHotelTitle"
			[useStoryblokCards]="false"
		>
			@if (promotionCodeStatus()) {
				<vp-alert
					[content]="
						promotionCodeStatus().translationKey
							| translate
								: {
										bookableStartDate:
											prettyPromotionDates().bookableFrom,
										bookableEndDate:
											prettyPromotionDates().bookableTo,
										discountPercentage:
											promotionCodeData().discount,
										visibleStartDate:
											prettyPromotionDates().visibleFrom,
										visibleEndDate:
											prettyPromotionDates().visibleTo,
								  }
					"
					[emphasized]="true"
					[subContent]="
						'storyblok.pages.promotion-code.form.promo-code.activated.description-note'
							| translate
					"
					[title]="
						'storyblok.pages.promotion-code.form.promo-code.activated.title'
							| translate
								: {
										promotionCode:
											promotionCodeData().promotionCode,
								  }
					"
					[type]="promotionCodeStatus().type"
					data-test-id="promotion-code-alert"
				/>
			}
		</sb-searchable-list-section>
	</div>
}
